// Offer Repository - Repository Pattern
import apiService from '../api.service';

class OfferRepository {
  // Get all offers
  async getAll() {
    return apiService.get('/offers');
  }

  // Get single offer
  async getById(id) {
    return apiService.get(`/offers/${id}`);
  }

  // Create offers (for multiple products)
  async create(data) {
    return apiService.post('/offers', data);
  }

  // Update offer
  async update(id, data) {
    return apiService.patch(`/offers/${id}`, data);
  }

  // Delete offer
  async delete(id) {
    return apiService.delete(`/offers/${id}`);
  }
}

export default new OfferRepository();
